// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__3sgXU","radio":"styles_radio__2Qvs0"};